const translations = {
  home: "Home",
  peopleKyc: "People & KYC",
  attendanceSalary: "Attendance & Salary",
  whatsappIngestion: "WhatsApp Orders",
  orders: "Orders",
  catalog: "Catalog",
  workshop: "Manufacturing Books",
  workerGoldBook: "Transaction Module",
  repair: "Repair",
  stock: "Ready Stock",
  barcodeTagging: "Barcode & Tagging",
  billing: "Billing & Invoices",
  rateCut: "Rate-Cut",
  ledger: "Gold & Material Ledger",
  reports: "Reports & Close",
  expenses: "Expenses",
  branches: "Branches",
  settings: "Settings",
  ownerEmail: "Owner Email Control",
  helpGuide: "Help & Guide",
  communications: "Communications",
  hardware: "Hardware",
  liveMetalRates: "Live Metal Rates",
  update: "Update",
  secureLogs: "Secure Logs",
  notSet: "Not set",
  group_home: "Home",
  group_retail: "Retail",
  group_people: "People",
  group_parties: "Parties & Business",
  group_manufacturing: "Manufacturing",
  group_accounts: "Accounts",
  group_transactions: "Transactions",
  group_gold_inventory: "Gold & Inventory",
  group_gold_stock: "Gold & Stock",
  group_billing: "Billing & Accounts",
  group_billing_only: "Billing",
  group_accounts_cash: "Accounts & Cash",
  group_payroll: "Payroll",
  group_portals: "Portals",
  group_documents: "Documents",
  group_reports: "Reports",
  group_reports_only: "Reports",
  group_settings: "Settings",
  group_administration: "Administration",
  group_ledger_sot: "Ledger (Source of Truth)",
  group_jewellery_structure: "Operations",
  group_master: "Master",
  group_transaction: "Transaction",
  group_barcode: "Barcode",
  group_production: "Production",
  group_utility: "Utility",
  group_avs_platform: "AVS Platform",
  group_scheme: "Scheme",
  group_gst_estimate: "GST / Estimate",
  group_bullion: "Bullion",
  subtitle_scheme: "Scheme master, accounts & receipts",
  subtitle_gst_estimate: "Retail GST / estimate / URD / challan",
  subtitle_bullion: "Sauda book & bullion ledger",
  item_opening_fine_cash: "Cash Fine Opening",
  item_sub_accounts: "Sub Acc. Master",
  item_dhadi_groups: "Dhadi Group",
  item_dhadi_book: "Dhadi Book",
  item_karigar_book: "Karigar Book",
  item_scheme: "Scheme Master",
  item_scheme_hub: "Scheme Hub",
  item_scheme_plans: "Scheme Master",
  item_scheme_accounts: "Scheme Account",
  item_scheme_receipt: "Scheme Receipt",
  item_scheme_receipts: "Scheme Receipt",
  item_scheme_report: "Scheme Report",
  item_cash_fine: "Cash ↔ Fine Transfer",
  item_item_txn_entry: "Item Transaction",
  item_patla: "Patla Stock",
  item_barcode_stock_rpt: "Barcode Stock",
  item_jangad: "Jangad Pending",
  item_vibrator: "Vibrator Out",
  item_day_wise: "Day Wise",
  item_tanch_hishob: "Tanch / Hisob",
  item_bullion_ledger: "Bullion Ledger",
  item_payment_nave: "Cash Payment / Nave",
  item_receipt_jama: "Cash Receipt / Jama",
  item_transfer_contra: "Transfer / Contra",
  item_accountwise: "Accountwise Summary / Details",
  item_item_jama_nave: "Itemwise Jama Nave",
  item_bank_transactions: "Bank Transactions",
  item_item_stock_rpt: "Item Stock",
  item_city_wise: "Item Jama Nave City Wise",
  item_acc_wise_sale_purchase: "Account Wise Sale Purchase",
  item_retail_sale_rpt: "Retail Sale Report",
  item_retail_sale: "Retail Sale GST / EST",
  item_retail_purchase: "Retail Purchase",
  subtitle_ledger_sot: "Authoritative cash, gold & high-value history",
  subtitle_jewellery_structure: "Operational workflow — reconciles to Ledger",
  subtitle_reports: "Offline jewellery books & registers",
  subtitle_billing_daily: "Daily sales, purchases & expenses",
  subtitle_transactions_daily: "Karigar gold, settlement & workshop txns",
  subtitle_manufacturing_daily: "Job cards, orders & production",
  subtitle_gold_stock_daily: "Counter stock, ledger & tagging",
  subtitle_master: "Firm, items, accounts, rates & openings",
  subtitle_transaction: "Sale, purchase, jama/nave, settlement",
  subtitle_payroll: "Employees, attendance & salary",
  subtitle_barcode: "Tags, scan, stock check & hardware",
  subtitle_production: "Dhadi, workshop, melt & outside work",
  subtitle_utility: "Migration, GST calc, reminders & backup",
  subtitle_avs_platform: "Customization, CRM, AI, branches & help",
  item_cash_book: "Cash Book",
  item_reconciliation_center: "Reconciliation Center",
  item_dashboard: "Dashboard",
  item_customers: "Account Master — Customers",
  item_suppliers: "Account Master — Suppliers",
  item_karigars: "Account Master — Karigars",
  item_employees: "Employee Master",
  item_crm: "CRM & Communications",
  item_orders: "Orders",
  item_job_cards: "Dhadi List / Job Cards",
  item_mfg_books: "Manufacturing Books",
  item_gold_book: "Karigar Issue / Return",
  item_outside_work: "Outside Work",
  item_polishing: "Polishing",
  item_meena: "Meena",
  item_mfg_material_making: "Manufacturing Material Making",
  item_tx_hub: "Transaction Module",
  item_qc_hallmark: "QC / Hallmark",
  item_melt: "Melt & Refinery",
  item_refinery: "Refinery Operations",
  item_gold_ledger: "Gold & Material Ledger",
  item_ready_stock: "Item Stock / Ready Stock",
  item_conversion: "Melting Process",
  item_melting_process: "Melting Process",
  item_barcode: "Barcode",
  item_barcode_scan: "Search / Scan Barcode",
  item_boxes: "Box & Tray Masters",
  item_transfers: "Stock Transfer",
  item_stones: "Stones & Diamonds",
  item_stock_audit: "Stock Check",
  item_stock_entry: "Item Opening Stock",
  item_lots: "Lot Wise / Tag Stock",
  item_catalog: "Item Design",
  item_item_masters: "Item Master",
  item_item_group: "Item Group",
  item_item_stamp: "Item Stamp",
  item_item_type: "Item Type",
  item_account_master: "Account Master",
  item_salary_group: "Salary Group",
  item_department_master: "Department Master",
  item_attendance_only: "Attendance",
  item_emp_payment: "Emp. Payment",
  item_emp_receipt: "Emp. Receipt",
  item_emp_salary: "Emp. Salary",
  item_barcode_stock_single: "Single Barcode Stock",
  item_barcode_stock_2: "Barcode Stock 2",
  item_barcode_print_scan: "Barcode Print / Scan",
  item_barcode_import: "Import Barcode",
  item_accountwise_summary: "Accountwise Summary",
  item_accountwise_details: "Accountwise Details",
  item_account_balance_2: "Account Balance 2",
  item_pay_rec_register: "Payment / Receipt Register",
  item_sale_fine: "Sale Fine",
  item_bullion: "Bullion",
  folder_payroll_masters: "Employee Masters",
  folder_payroll_pay: "Pay & Salary",
  item_rate_master: "Rate Master",
  item_firm_master: "Firm Master",
  item_counter: "Counter Number",
  item_sales: "Sale",
  item_purchases: "Purchase",
  item_estimates: "Estimate",
  item_dc: "Delivery Challan",
  item_urd: "URD Purchase",
  item_credit_note: "Credit Note",
  item_debit_note: "Debit Note",
  item_vouchers: "Payment / Receipt",
  item_bank_rec: "Bank Reconciliation",
  item_expenses: "Expenses",
  item_gold_settlement: "Settlement",
  item_sauda: "Bullion / Sauda Book",
  item_fine_margin: "Fine Margin",
  item_item_txn: "Item Transaction Register",
  item_deleted_bills: "Delete Sale / Purchase Bills",
  item_coa: "Account Group",
  item_repair_orders: "Repair Orders",
  item_attendance: "Attendance & Salary",
  item_reports: "Reports Hub",
  item_daily_summary: "Daily Summary",
  item_fine_rojmel: "Fine Rojmel",
  item_dar_rojmel: "Dar Rojmel",
  item_account_balance: "Account Balance",
  item_gst_returns: "GST Returns",
  item_erp_audit: "ERP Audit",
  item_utilities: "Utilities Hub",
  item_gst_calc: "GST Calculator",
  item_reminders: "Reminders",
  item_wipeout: "Period Close / Wipeout",
  item_backup: "Backup & Recovery",
  item_ledgers: "Gold & Material Ledger",
  item_tally: "Tally Export",
  item_ceo: "CEO Dashboard",
  item_customization: "Customization",
  item_users_settings: "User Master",
  item_migration: "Transfer Data",
  item_branches: "Branches",
  item_whatsapp: "WhatsApp Status",
  item_email_comms: "Email & Comms",
  item_help: "Help & Guided Tours",
  item_assistant: "AI Assistant",
  item_notifications: "Notifications",
  item_hardware: "Weight Scan / Hardware",
  more_forms: "More forms…",
  more_forms_hint: "Additional screens from this menu — same as Offline ERP, shown when you need them.",
  folder_accounts: "Accounts",
  folder_ac_group: "A/c Group",
  folder_item: "Item",
  folder_stamp: "Stamp",
  folder_stones: "Dia/Stone Setup",
  folder_opening_stock: "Opening Stock",
  folder_company: "Company Detail",
  folder_users: "User Passwords",
  folder_pay_rec: "Payment / Receipt",
  folder_karigar_txn: "Karigar Issue / Return",
  folder_barcode_stock: "Barcode Stock",
  folder_cheque: "Cheque",
  item_cheque_print: "Print",
  item_cheque_register: "Register",
  item_cheque_checkbook: "Checkbook",
  folder_box_tag: "Box Tag",
  item_box_tag_in: "Box Tag In",
  item_box_tag_out: "Box Tag Out",
  folder_daily_books: "Daily Books",
  folder_account_reports: "Account Reports",
  folder_stock_reports: "Stock Reports",
  folder_dhadi: "Dhadi / Job Cards",
  folder_outside: "Outside Work",
  mobile_home: "Home",
  mobile_sell: "Sell",
  mobile_make: "Make",
  mobile_money: "Money",
  mobile_stock: "Stock",
  mobile_karigar: "Production",
  mobile_business: "Transaction",
  mobile_production: "Production",
  mobile_transaction: "Transaction",
  mobile_reports: "Reports",
  mobile_more: "More",
  mobile_meena: "Meena Book",
  mobile_polishing: "Polishing",
  mobile_sync: "Sync Status",
  mobile_parties_desc: "Customers, suppliers, karigars",
};

export default translations;
